import RedemptionModal from './RedemptionModal.mjs';
import RedemptionModalSuccess from './RedemptionModalSuccess.mjs';
import RedemptionModalError from "./RedemptionModalError.mjs";
import {pluralize} from '../utils.mjs';

export default function Redemption({userAccount, preferredLocation, totalCost, perks}) {
  const perkNames = perks.map((perk) => {
    const editedName = perk.fullName.replace("1 ", "");
    return pluralize(perk.qty, editedName);
  });

  return (
    <>
      <RedemptionModal userAccount={userAccount} preferredLocation={preferredLocation} totalCost={totalCost} perks={perks} perkNames={perkNames} />
      <RedemptionModalSuccess />
      <RedemptionModalError />
    </>
  )
}
